import {Suspense} from 'react'

import {useSelector} from '@xstate/react'

import useOverlayManagerInterpreter from '@hooks/use-overlay-manager-interpreter.hook'

export default function OverlayManager() {
  const service = useOverlayManagerInterpreter()
  const Component = useSelector(service, (state) => state.context.component)
  const isClosed = useSelector(service, (state) => state.matches('closed'))
  const isOpen = useSelector(service, (state) => state.matches('opened'))

  if (isClosed) {
    return null
  }

  const props = {
    isOpen,
    onClose: () => service.send({type: 'CLOSE'}),
  }

  if (!Component) {
    return null
  }

  return (
    <Suspense fallback={null}>
      <Component {...props} />
    </Suspense>
  )
}
